<template>
  <div
    :class="[
      'abnner',
      { 'abnner--right': banner.content_position === 'right' },
    ]"
  >
    <img :src="bgImage" class="abnner__bg" :alt="banner.title"/>
    <div :style="{ color: banner.text_color }" class="abnner__content">
      <div
        v-if="banner.title"
        class="abnner__title h3"
        v-html="banner.title"
      ></div>
      <div
        v-if="banner.description"
        class="abnner__description"
        v-html="banner.description"
      ></div>
      <div class="abnner__btn">
        <button
          type="button"
          class="btn btn-white btn-small stretched-link"
          data-popup-with-chats
          :data-popup-with-chats-title="
            banner.text_button || 'Узнать подробнее'
          "
          @click="$emit('click', $event, banner)"
        >
          {{ banner.text_button || "Узнать подробнее" }}
        </button>
      </div>
      <div
        v-if="banner.agreement_text"
        class="abnner__footnote"
        v-html="banner.agreement_text"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    banner: {
      type: Object,
      required: true,
    },
  },
  emits: ["click"],
  data() {
    return {
      isMobile: false,
    };
  },
  computed: {
    bgImage() {
      return this.isMobile ? this.banner?.image?.image_mobile : this.banner?.image?.source
    },
  },
  mounted() {
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkMobile);
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 575;
    },
  },
};
</script>

<style scoped>
.abnner {
  padding: 0px;
  position: relative;
}
.abnner--right {
  text-align: right;
}
.abnner__bg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.abnner__content {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 35px 40px;
  color: #fff;
  font-weight: 300;
}
.abnner__title {
  font-size: 36px;
  letter-spacing: -0.03em;
  margin-bottom: 12px;
}
.abnner__title:last-child {
  margin-bottom: 0;
}

.abnner__description {
  line-height: 1.5;
  margin-bottom: 42px;
}

.abnner__footnote {
  opacity: 0.6;
  font-size: 11px;
  line-height: 1.2;
}

@media (max-width: 1279px) {
  .abnner__title {
    font-size: 32px;
  }
}
@media (min-width: 992px) {
  .abnner__title {
    line-height: 1.1;
  }
}

@media (max-width: 991px) {
   .abnner__content {
    padding: 15px 17px;
    justify-content: unset;
   }
  .abnner__title {
    font-size: 16px;
    margin-bottom: 10px;
  }
  .abnner__description {
    font-size: 13px;
    margin-bottom: 10px;
    line-height: 1;
  }
  .abnner__btn .btn {
    padding: 4px 13px;
    font-size: 12px;
  }
}
</style>
